module.exports = __webpack_public_path__ + "img/banche_invoiceweb.d52fc0c6.png";